import { RuntimeFrame } from './RuntimeFrame.js'
import { RuntimeNode } from './RuntimeNode.js'

class RuntimeFactory {
    componentLibrary;
    eventBroker;
    context;
    progressbarService;

    constructor(componentLibrary, eventBroker, context, progressbarService) {
        this.componentLibrary = componentLibrary;
        this.eventBroker = eventBroker;
        this.context = context;
        this.progressbarService = progressbarService;
    }

    getFrame(frameDefinition, rtFactory) {
        return new RuntimeFrame(this.eventBroker, frameDefinition, rtFactory);
    }

    getNode(nodeDefinition, rtFactory) {
        return new RuntimeNode(this.eventBroker, this.context, this.progressbarService, nodeDefinition, rtFactory);
    }

    getComponent(componentDefinition) {
        var newComponent = this.componentLibrary.createNewInstance(componentDefinition.type, componentDefinition.id);
        newComponent.eventBroker = this.eventBroker;
        newComponent.importModel(componentDefinition.model);
        newComponent.hookupLiquidTexts();
        return newComponent;
    }
}

export { RuntimeFactory }